//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('listDataLang', {
//        templateUrl: 'views/components/views/listDataLang/listDataLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'listDataLangService', function ($stateParams, stateService, listDataLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let listDataKeyno = $stateParams.listdata_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadDataLanguages() {
//                vm.model.inputListLanguages = await listDataLangService.listDataLanguages({ listdata_keyno: listDataKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                listDataLangService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    stateService.back();
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadDataLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
